import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router";
import { ROUTE_MOBILE_VERIFICATION,Dexter_Splash3 } from "../../Routes";
import { ToastContainer } from "react-toastify";
import Toast from "../ToastMsg/Toast";

function ProtectedLayout() {
  const navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const isAuthenticated = storedToken !== null;
  let ShowToast = false;

  useEffect(() => {
    if (!isAuthenticated) {
      if (!ShowToast) {
        ShowToast = true;
        Toast.error("please login again");
      }
      navigate(Dexter_Splash3, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) return <div>Loading...</div>;

  return <Outlet />;
}
<ToastContainer />;

export default ProtectedLayout;
